
var swiper = new Swiper(".homeSlider", {
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="' + className + '">' + (index + 1) + "</span>";
    },
  },
});

var swiper = new Swiper(".mobieCategory", {
  slidesPerView: 1,
  spaceBetween: 10,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    0: {
      slidesPerView: 5,
      spaceBetween: 10,
    },
    768: {
      slidesPerView: 5,
      spaceBetween: 40,
    },
    1024: {
      slidesPerView: 5,
      spaceBetween: 50,
    },
  },
});

var swiper = new Swiper(".productItems", {
  slidesPerView: 1,
  spaceBetween: 10,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    0: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 40,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 50,
    },
  },
});


const navbar = document.querySelector('.navmain');

window.addEventListener('scroll', () => {
  if (window.pageYOffset > 0) {
    navbar.classList.add('scrolldiv');
  } else {
    navbar.classList.remove('scrolldiv');
  }
});

function decreaseCount(event, elem) {
  event.preventDefault();
  var inputElem = elem.nextElementSibling;
  var value = parseInt(inputElem.value);
  if (value > 1) {
    inputElem.value = value - 1;
  }
}

function increaseCount(event, elem) {
  event.preventDefault();
  var inputElem = elem.previousElementSibling;
  var value = parseInt(inputElem.value);
  inputElem.value = value + 1;
}



const readMoreBtns = document.querySelectorAll('.read-more-btn');
const descriptions = document.querySelectorAll('.description');

readMoreBtns.forEach(function(btn, index) {
  const description = descriptions[index];

  btn.addEventListener('click', function() {
    if (description.style.maxHeight) {
      description.style.maxHeight = null;
      btn.textContent = 'Read More';
    } else {
      description.style.maxHeight = description.scrollHeight + 'px';
      btn.textContent = 'Read Less';
    }
  });
});




var swiper = new Swiper(".trustSection", {
  slidesPerView: 1,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    0: {
      slidesPerView:2,
      spaceBetween:10,
    },
    768: {
      slidesPerView:3,
      spaceBetween:20,
    },
    1024: {
      slidesPerView:4,
      spaceBetween:30,
    },
  },
});






var swiper = new Swiper(".docTestimonisl", {
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    0: {
      slidesPerView:1,
      spaceBetween:20,
    },
    768: {
      slidesPerView:2,
      spaceBetween:20,
    },
    1024: {
      slidesPerView:3,
      spaceBetween:20,
    },
  },
});


var swiper = new Swiper(".reviewSection", {
  slidesPerView: 1,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    0: {
      slidesPerView:1,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 4,
      spaceBetween: 40,
    },
    1024: {
      slidesPerView:3,
      spaceBetween:30,
    },
  },
});


  var acc = document.getElementsByClassName("accordion");
  var i;
  
  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      } 
    });
  }